const EMPTY_PARAMETERS = Object.freeze(Object.create(null));
export class Messages {
    translator;
    constructor(translator) {
        this.translator = translator;
    }
    WORDMARK_LABEL() {
        return this.translator.translate('WORDMARK_LABEL', EMPTY_PARAMETERS);
    }
    ACCOUNT_MENU_DESKTOP_LABEL(email) {
        return this.translator.translate('ACCOUNT_MENU_DESKTOP_LABEL', { email });
    }
    ACCOUNT_MENU_PHONE_LABEL(email) {
        return this.translator.translate('ACCOUNT_MENU_PHONE_LABEL', { email });
    }
    ACCOUNT_MENU_SIGNED_IN_AS() {
        return this.translator.translate('ACCOUNT_MENU_SIGNED_IN_AS', EMPTY_PARAMETERS);
    }
    ACCOUNT_MENU_SIGN_OUT() {
        return this.translator.translate('ACCOUNT_MENU_SIGN_OUT', EMPTY_PARAMETERS);
    }
    SESSION_SIGNING_OUT() {
        return this.translator.translate('SESSION_SIGNING_OUT', EMPTY_PARAMETERS);
    }
    TRIPS_PAGE_TITLE() {
        return this.translator.translate('TRIPS_PAGE_TITLE', EMPTY_PARAMETERS);
    }
    TRIPS_EMPTY_TITLE() {
        return this.translator.translate('TRIPS_EMPTY_TITLE', EMPTY_PARAMETERS);
    }
    TRIPS_EMPTY_BODY() {
        return this.translator.translate('TRIPS_EMPTY_BODY', EMPTY_PARAMETERS);
    }
    TRIPS_NEW_TRIP() {
        return this.translator.translate('TRIPS_NEW_TRIP', EMPTY_PARAMETERS);
    }
    TRIPS_GROUP_UPCOMING() {
        return this.translator.translate('TRIPS_GROUP_UPCOMING', EMPTY_PARAMETERS);
    }
    TRIPS_GROUP_NO_DATES() {
        return this.translator.translate('TRIPS_GROUP_NO_DATES', EMPTY_PARAMETERS);
    }
    TRIPS_GROUP_PAST() {
        return this.translator.translate('TRIPS_GROUP_PAST', EMPTY_PARAMETERS);
    }
    TRIPS_NO_DATES() {
        return this.translator.translate('TRIPS_NO_DATES', EMPTY_PARAMETERS);
    }
    TRIPS_LOADING() {
        return this.translator.translate('TRIPS_LOADING', EMPTY_PARAMETERS);
    }
    TRIPS_LOAD_FAILED_TITLE() {
        return this.translator.translate('TRIPS_LOAD_FAILED_TITLE', EMPTY_PARAMETERS);
    }
    TRIPS_LOAD_FAILED_BODY() {
        return this.translator.translate('TRIPS_LOAD_FAILED_BODY', EMPTY_PARAMETERS);
    }
    NEW_TRIP_DIALOG_TITLE() {
        return this.translator.translate('NEW_TRIP_DIALOG_TITLE', EMPTY_PARAMETERS);
    }
    NEW_TRIP_CLOSE() {
        return this.translator.translate('NEW_TRIP_CLOSE', EMPTY_PARAMETERS);
    }
    NEW_TRIP_TITLE_LABEL() {
        return this.translator.translate('NEW_TRIP_TITLE_LABEL', EMPTY_PARAMETERS);
    }
    NEW_TRIP_TITLE_PLACEHOLDER() {
        return this.translator.translate('NEW_TRIP_TITLE_PLACEHOLDER', EMPTY_PARAMETERS);
    }
    NEW_TRIP_TITLE_HINT() {
        return this.translator.translate('NEW_TRIP_TITLE_HINT', EMPTY_PARAMETERS);
    }
    NEW_TRIP_CANCEL() {
        return this.translator.translate('NEW_TRIP_CANCEL', EMPTY_PARAMETERS);
    }
    NEW_TRIP_CREATE() {
        return this.translator.translate('NEW_TRIP_CREATE', EMPTY_PARAMETERS);
    }
    NEW_TRIP_CREATING() {
        return this.translator.translate('NEW_TRIP_CREATING', EMPTY_PARAMETERS);
    }
    NEW_TRIP_TITLE_REQUIRED() {
        return this.translator.translate('NEW_TRIP_TITLE_REQUIRED', EMPTY_PARAMETERS);
    }
    NEW_TRIP_FAILED_TITLE() {
        return this.translator.translate('NEW_TRIP_FAILED_TITLE', EMPTY_PARAMETERS);
    }
    NEW_TRIP_FAILED_BODY() {
        return this.translator.translate('NEW_TRIP_FAILED_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_WORDMARK_LABEL() {
        return this.translator.translate('SIGN_IN_WORDMARK_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_TITLE() {
        return this.translator.translate('SIGN_IN_EMAIL_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_DESCRIPTION() {
        return this.translator.translate('SIGN_IN_EMAIL_DESCRIPTION', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_LABEL() {
        return this.translator.translate('SIGN_IN_EMAIL_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_EMAIL_PLACEHOLDER() {
        return this.translator.translate('SIGN_IN_EMAIL_PLACEHOLDER', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_CODE() {
        return this.translator.translate('SIGN_IN_SEND_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_SENDING_CODE() {
        return this.translator.translate('SIGN_IN_SENDING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_ACCOUNT_NOTE() {
        return this.translator.translate('SIGN_IN_NEW_ACCOUNT_NOTE', EMPTY_PARAMETERS);
    }
    SIGN_IN_INVALID_EMAIL() {
        return this.translator.translate('SIGN_IN_INVALID_EMAIL', EMPTY_PARAMETERS);
    }
    SIGN_IN_USE_DIFFERENT_EMAIL() {
        return this.translator.translate('SIGN_IN_USE_DIFFERENT_EMAIL', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_TITLE() {
        return this.translator.translate('SIGN_IN_CODE_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_DESCRIPTION(email, children) {
        return this.translator.translateWithChildren('SIGN_IN_CODE_DESCRIPTION', { email }, children);
    }
    SIGN_IN_CODE_LABEL() {
        return this.translator.translate('SIGN_IN_CODE_LABEL', EMPTY_PARAMETERS);
    }
    SIGN_IN_SUBMIT_CODE() {
        return this.translator.translate('SIGN_IN_SUBMIT_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CHECKING_CODE() {
        return this.translator.translate('SIGN_IN_CHECKING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_COUNTDOWN() {
        return this.translator.translate('SIGN_IN_RESEND_COUNTDOWN', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_AVAILABLE() {
        return this.translator.translate('SIGN_IN_RESEND_AVAILABLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_CODE() {
        return this.translator.translate('SIGN_IN_RESEND_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESENDING_CODE() {
        return this.translator.translate('SIGN_IN_RESENDING_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_RESEND_ANNOUNCEMENT() {
        return this.translator.translate('SIGN_IN_RESEND_ANNOUNCEMENT', EMPTY_PARAMETERS);
    }
    SIGN_IN_WRONG_CODE_ATTEMPTS_LEFT(attemptsLeft) {
        return this.translator.translate('SIGN_IN_WRONG_CODE_ATTEMPTS_LEFT', { attemptsLeft });
    }
    SIGN_IN_WRONG_CODE_ONE_ATTEMPT_LEFT() {
        return this.translator.translate('SIGN_IN_WRONG_CODE_ONE_ATTEMPT_LEFT', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_CODE_SENT_TITLE() {
        return this.translator.translate('SIGN_IN_NEW_CODE_SENT_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_NEW_CODE_SENT_BODY() {
        return this.translator.translate('SIGN_IN_NEW_CODE_SENT_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EXPIRED_TITLE() {
        return this.translator.translate('SIGN_IN_CODE_EXPIRED_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EXPIRED_BODY() {
        return this.translator.translate('SIGN_IN_CODE_EXPIRED_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_ATTEMPTS_TITLE() {
        return this.translator.translate('SIGN_IN_TOO_MANY_ATTEMPTS_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_ATTEMPTS_BODY() {
        return this.translator.translate('SIGN_IN_TOO_MANY_ATTEMPTS_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_NEW_CODE() {
        return this.translator.translate('SIGN_IN_SEND_NEW_CODE', EMPTY_PARAMETERS);
    }
    SIGN_IN_SEND_NEW_CODE_IN(time) {
        return this.translator.translate('SIGN_IN_SEND_NEW_CODE_IN', { time });
    }
    SIGN_IN_TOO_MANY_CODES_TITLE() {
        return this.translator.translate('SIGN_IN_TOO_MANY_CODES_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_TOO_MANY_CODES_BODY() {
        return this.translator.translate('SIGN_IN_TOO_MANY_CODES_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_UNAVAILABLE_TITLE() {
        return this.translator.translate('SIGN_IN_UNAVAILABLE_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_UNAVAILABLE_BODY() {
        return this.translator.translate('SIGN_IN_UNAVAILABLE_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_SIGNED_OUT_TITLE() {
        return this.translator.translate('SIGN_IN_SIGNED_OUT_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_SIGNED_OUT_BODY() {
        return this.translator.translate('SIGN_IN_SIGNED_OUT_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_OR() {
        return this.translator.translate('SIGN_IN_OR', EMPTY_PARAMETERS);
    }
    SIGN_IN_SIGNING_IN_WITH_GOOGLE() {
        return this.translator.translate('SIGN_IN_SIGNING_IN_WITH_GOOGLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_GOOGLE_REJECTED_TITLE() {
        return this.translator.translate('SIGN_IN_GOOGLE_REJECTED_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_GOOGLE_REJECTED_BODY() {
        return this.translator.translate('SIGN_IN_GOOGLE_REJECTED_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_GOOGLE_UNAVAILABLE_TITLE() {
        return this.translator.translate('SIGN_IN_GOOGLE_UNAVAILABLE_TITLE', EMPTY_PARAMETERS);
    }
    SIGN_IN_GOOGLE_UNAVAILABLE_BODY() {
        return this.translator.translate('SIGN_IN_GOOGLE_UNAVAILABLE_BODY', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EMAIL_SUBJECT() {
        return this.translator.translate('SIGN_IN_CODE_EMAIL_SUBJECT', EMPTY_PARAMETERS);
    }
    SIGN_IN_CODE_EMAIL_BODY(code) {
        return this.translator.translate('SIGN_IN_CODE_EMAIL_BODY', { code });
    }
}
//# sourceMappingURL=Messages.js.map